export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue) {
    Vue.prototype.getReportDate = () => {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1 // January is 0!

      var yyyy = today.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }

      var date = dd + '-' + mm + '-' + yyyy

      return date
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/reportDate.js